// extracted by mini-css-extract-plugin
export var offerSection = "OfferSection-module--offer-section--2vkv_";
export var offerSection__icon = "OfferSection-module--offer-section__icon--3WMPv";
export var offerSection__iconSmall = "OfferSection-module--offer-section__icon-small--2g0b_";
export var offerSection__content = "OfferSection-module--offer-section__content--uTAlR";
export var offerSection__contentHeading = "OfferSection-module--offer-section__content-heading--3AMBS";